// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"c860ec41","338":"edb71933","506":"7f026665","605":"585ffba0","693":"ba0d9e7c","805":"b6687913","910":"b4b55f5a"}[chunkId] + ".chunk.js";
};